import {esNormativaV2} from './normativa.utils'

export const TIPO_DTE = {
  FACTURA: '01',
  CREDITO_FISCAL: '03',
  NOTA_REMISION: '04',
  NOTA_CREDITO: '05',
  NOTA_DEBITO: '06',
  COMPROBANTE_RETENCION: '07',
  COMPROBANTE_LIQUIDACION: '08',
  DOCUMENTO_LIQUIDACION: '09',
  FACTURA_EXPORTACION: '11',
  SUJETO_EXCLUIDO: '14',
  COMPROBANTE_DONACION: '15',
} as const

export const VERSION_DTE_DESCONOCIDA = 0

export const VERSION_DTE_NORMATIVA_V1: Readonly<Record<string, number>> = {
  [TIPO_DTE.FACTURA]: 1,
  [TIPO_DTE.CREDITO_FISCAL]: 3,
  [TIPO_DTE.NOTA_REMISION]: 3,
  [TIPO_DTE.NOTA_CREDITO]: 3,
  [TIPO_DTE.NOTA_DEBITO]: 3,
  [TIPO_DTE.COMPROBANTE_RETENCION]: 1,
  [TIPO_DTE.COMPROBANTE_LIQUIDACION]: 1,
  [TIPO_DTE.DOCUMENTO_LIQUIDACION]: 1,
  [TIPO_DTE.FACTURA_EXPORTACION]: 1,
  [TIPO_DTE.SUJETO_EXCLUIDO]: 1,
  [TIPO_DTE.COMPROBANTE_DONACION]: 1,
}

export const VERSION_DTE_NORMATIVA_V2: Readonly<Record<string, number>> = {
  [TIPO_DTE.FACTURA]: 2,
  [TIPO_DTE.CREDITO_FISCAL]: 4,
  [TIPO_DTE.NOTA_REMISION]: 4,
  [TIPO_DTE.NOTA_CREDITO]: 4,
  [TIPO_DTE.NOTA_DEBITO]: 4,
  [TIPO_DTE.COMPROBANTE_RETENCION]: 2,
  [TIPO_DTE.COMPROBANTE_LIQUIDACION]: 2,
  [TIPO_DTE.DOCUMENTO_LIQUIDACION]: 2,
  [TIPO_DTE.FACTURA_EXPORTACION]: 3,
  [TIPO_DTE.SUJETO_EXCLUIDO]: 2,
  [TIPO_DTE.COMPROBANTE_DONACION]: 2,
}

export const normalizarTipoDte = (tipoDte: any): string => `${tipoDte ?? ''}`.trim()

export const versionDteNormativaV1 = (tipoDte: any): number =>
  VERSION_DTE_NORMATIVA_V1[normalizarTipoDte(tipoDte)] ?? VERSION_DTE_DESCONOCIDA

export const versionDteNormativaV2 = (tipoDte: any): number =>
  VERSION_DTE_NORMATIVA_V2[normalizarTipoDte(tipoDte)] ?? VERSION_DTE_DESCONOCIDA

export const versionDteEmision = (tipoDte: any, empresa: any): number =>
  esNormativaV2(empresa) ? versionDteNormativaV2(tipoDte) : versionDteNormativaV1(tipoDte)

export const versionDteDocumento = (detallesDte: any): number => {
  const version = Number(`${detallesDte?.identificacion?.version ?? ''}`.trim())
  return Number.isFinite(version) && version > 0 ? version : VERSION_DTE_DESCONOCIDA
}

export const esDocumentoNormativaV2 = (tipoDte: any, versionDte: number): boolean => {
  const version = versionDteNormativaV2(tipoDte)
  return version !== VERSION_DTE_DESCONOCIDA && version === versionDte
}

export const esDocumentoNormativaV1 = (tipoDte: any, versionDte: number): boolean => {
  const version = versionDteNormativaV1(tipoDte)
  return version !== VERSION_DTE_DESCONOCIDA && version === versionDte
}
